import { ReactNode, useContext } from 'react'
import BigNumber from 'bignumber.js'
import CurrencyInputPanel from 'components/CurrencyInputPanel'
import { ModalActions } from 'components/Modal'
import { useTranslation } from 'contexts/Localization'
import useActiveWeb3React from 'hooks/useActiveWeb3React'
import { useCurrencyBalance } from 'state/wallet/hooks'
import tokens from 'config/constants/tokens'
import { Box, Button, Flex, useMatchBreakpoints } from 'vvs-uikit'
import xVvsContext from 'views/xVvs/context'
import usePriceXvvsUsdc from 'views/xVvs/hooks/usePriceXvvsUsdc'

interface Props {
  remark: ReactNode
}

const InputStep = ({ remark }: Props) => {
  const { t } = useTranslation()
  const { account } = useActiveWeb3React()
  const { error, onChange, goNext, state } = useContext(xVvsContext)
  const { value } = state
  const isValid = !error
  const balance = useCurrencyBalance(account, tokens.xvvs)

  const insufficientAmount = balance && new BigNumber(value || 0).gt(balance.toExact())
  const disableTransaction = value === '' || new BigNumber(value).eq(0) || insufficientAmount

  const xvvsPriceUsd = usePriceXvvsUsdc()
  const valueInUsdHint = xvvsPriceUsd.times(value || 0)

  const { isMobile } = useMatchBreakpoints()

  return (
    <Box p="0 24px">
      <CurrencyInputPanel
        label={t('Deposit Amount')}
        value={value}
        showMaxButton={false}
        currency={tokens.xvvs}
        onUserInput={onChange}
        disableCurrencySelect
        id="lock-modal-input"
        showPercentageButtons
        valueInUsdHint={valueInUsdHint}
      />
      {remark}
      <ModalActions>
        <Flex paddingBottom={isMobile ? '48px' : 0}>
          <Button
            width="100%"
            disabled={!isValid || disableTransaction}
            onClick={() => {
              goNext()
            }}
          >
            {!isValid ? error : insufficientAmount ? t('Insufficient xVVS balance') : t('Deposit in Vault')}
          </Button>
        </Flex>
      </ModalActions>
    </Box>
  )
}

export default InputStep
